module.exports = __webpack_public_path__ + "assets/img/redpacket-bg.89b7f310.png";